















































import {Component, Mixins} from "vue-property-decorator";
import Carousel from "@/components/for-auth-view/Carousel.vue";
import XButton from "@/components/SimpleButton.vue";
import ButtonWithMessage
  from "@/components/for-auth-view/ButtonWithMessage.vue";
import AppApiMixin from "@/components/mixins/AppApi.vue";

@Component({
  components: {
    Carousel,
    XButton,
    ButtonWithMessage,
  },
})
class Auth extends Mixins(AppApiMixin) {
  get showCarousel() {
    const {sm, xs} = this.$vuetify.breakpoint;
    return !sm && !xs;
  }

  public mounted() {
    this.getAppConfig();
  }

  get isSignUpPage(): boolean {
    return this.$route.name === "signUp";
  }

  openAgreement() {
    const routeData = this.$router.resolve({name: 'agreement'});
    window.open(routeData.href, '_blank');
  }

  openHelp() {
    const routeData = this.$router.resolve({name: 'help'});
    window.open(routeData.href, '_blank');
  }
}

export default Auth;
